<template>
  <div id="gestion-equipes">
    <div v-if="mainStore.bookingSystem.equipes.has_equipes">
      <div class="text-h6 font-weight-bold my-3"><v-icon icon="mdi-account-group" color="primary"
          size="xs-small"></v-icon> Mes équipes</div>
      <EquipeItem v-for="(equipe, index) in mainStore.bookingSystem.equipes.list" :key="index" :item="equipe"
        :index="index" @deleteEquipe="show_delete_equipe(index)" />


      <v-dialog v-model="show_confirm_delete_equipe" width="500" max-width="100%" scroll-strategy="none">
        <v-card>
          <v-card-text>
            <div class="text-body-1">Voulez-vous vraiment <b>supprimer</b> cette équipe ?</div>
            <div>L'équipe ainsi que tous les coureurs associés seront supprimés.</div>
          </v-card-text>
          <v-card-actions>
            <v-btn color="red-darken-4" @click="show_confirm_delete_equipe = false">Non</v-btn>
            <v-btn color="green-darken-4" @click="delete_equipe_confirm">Oui</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from "@/stores/bookingStore";
import EquipeItem from '@/components/Inscription/GestionEquipes/EquipeItem.vue';


export default {
  components: { EquipeItem },
  data() {
    return {
      index_equipe_to_delete: null,
      show_confirm_delete_equipe: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    buyDossardBourseView() {
      return this.$route.name == "BuyDossardBourse";
    },
  },
  watch: {
    'bookingStore.inscriptions': {
      deep: true,
      handler() {
        const add_missing_inscriptions = false;
        this.mainStore.bookingSystem.equipes.assign_teams(add_missing_inscriptions);
      },
    },
  },

  methods: {
    show_delete_equipe(index) {
      this.show_confirm_delete_equipe = true;
      this.index_equipe_to_delete = index;
    },
    delete_equipe_confirm() {
      this.show_confirm_delete_equipe = false;
      this.bookingStore.deleteInscriptionsFromEquipe(this.mainStore.bookingSystem.equipes.list[this.index_equipe_to_delete]);
      this.bookingStore.compute_cart();
      this.mainStore.bookingSystem.preselection = null;
      this.index_equipe_to_delete = null;
    },

  },
};
</script>

<style lang="scss" scoped></style>